import script from "./WinHand.vue?vue&type=script&setup=true&lang=js"
export * from "./WinHand.vue?vue&type=script&setup=true&lang=js"

import "./WinHand.vue?vue&type=style&index=0&id=5d55a9f3&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d55a9f3"]])

export default __exports__